import { BaseEntity } from '@core/entities/_extra';
import { Expose, Type } from 'class-transformer';
import { SafeUrl } from '@angular/platform-browser';

export class EmailEntity extends BaseEntity {
  @Expose({ name: 'template_type' })
  templateType = '';

  subject = '';

  @Expose({ name: 'template_body' })
  templateBody = '';

  @Expose({ name: 'header_content' })
  headerContent = '';

  @Expose({ name: 'footer_content' })
  footerContent = '';

  url = '';

  // for ui template use
  imageUrl: SafeUrl;

  @Expose({ name: 'template_logo' })
  @Type(() => TemplateLogo)
  templateLogo: TemplateLogo[];

  constructor(init?: Partial<EmailEntity>) {
    super();
    this.initEntity(init);
  }

  get image(): string {
    return this.templateLogo[0].templateImage;
  }
}

class TemplateLogo {
  @Expose({ name: 'template_id' })
  templateId: number;

  @Expose({ name: 'template_image' })
  templateImage: string;
}
